import React, { 
    useState, 
    useEffect } from 'react';
import { 
    Card,
    Button,
    notification,
    Drawer,
    Result } from 'antd';
import axios from 'axios';

import {
    PhoneOutlined,
    MessageOutlined,
    SmileOutlined
} from '@ant-design/icons';

import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3'; 

import { useIdleTimer } from 'react-idle-timer'

import ContactInfo from './service-config/ContactInfo';
import CartTotals from './order-summary/CartTotals';
import Upsells from './order-summary/Upsells';
import EditServiceButtons from './order-summary/EditServiceButtons';
import OrderCompletionSteps from './order-summary/OrderCompletionSteps';
import ServiceAddress from './service-config/ServiceAddress';
import ActivationDate from './service-config/ActivationDate';
import PaymentDetails from './service-config/PaymentDetails';
import logo from '../../images/start-koodo-logo-v2.png';
import Referrals from './order-summary/Referrals';
import TVServices from './products/TVServices';
import InternetServices from './products/InternetServices';
import PhoneServices from './products/PhoneServices';

const siteDomain = headerVars.siteDomain;

function Cart() {
    const [cartUpdateState, setCartUpdateState] = useState('');
    const [cartItemsMarkup, setCartItemsMarkup] = useState(
        <Card loading={ true } title={ '' }></Card>
    );
    const [cartTotalsMarkup, setCartTotalsMarkup] = useState(<></>);
    const [firstNameValid, setFirstNameValid] = useState(false);
    const [lastNameValid, setLastNameValid] = useState(false);
    const [phoneNumberValid, setPhoneNumberValid] = useState(false);
    const [emailValid, setEmailValid] = useState(false);
    const [firstName, setFirstName] = useState(headerVars.customerFirstName);
    const [lastName, setLastName] = useState(headerVars.customerLastName);
    const [email, setEmail] = useState(headerVars.customerEmail);
    const [phone, setPhone] = useState(headerVars.customerPhone);
    const [lineType, setLineType] = useState( ( headerVars.customerLineType != '' ) ? headerVars.customerLineType : 'cell' );
    const [canContactCustomer, setCanContactCustomer] = useState(( headerVars.dataCollectionOptin != '' ) ? headerVars.dataCollectionOptin : false);
    const [qualifiedAddress, setQualifiedAddress] = useState(window.headerVars.qualifiedAddress);
    const [qualificationObject, setQualificationObject] = useState(jQuery("#qualificationData").val());
    const [cartHasItems, setCartHasItems] = useState( false );
    const [orderConfirmationNumber, setOrderConfirmationNumber] = useState( '' );
    const [contactInfoComponentCompleted, setContactInfoComponentCompleted] = useState(false);
    const [serviceAddressComponentCompleted, setServiceAddressComponentCompleted] = useState(false);
    const [activationComponentCompleted, setActivationComponentCompleted] = useState(false);
    const [paymentComponentCompleted, setPaymentComponentCompleted] = useState(false);
    const [paymentReceived, setPaymentReceived] = useState(false);
    const [progressCount, setProgressCount] = useState(0);    
    const [tvDrawerOpen, setTvDrawerOpen] = useState(false);
    const [internetDrawerOpen, setInternetDrawerOpen] = useState(false);
    const [phoneDrawerOpen, setPhoneDrawerOpen] = useState(false);
    const [deletingItemFromCart, setDeletingItemFromCart] = useState(false);
    const [isD2C, setIsD2C] = useState(false);
    const [paymentIsProcessing, setPaymentIsProcessing] = useState(false);
    const [shippingAddress, setShippingAddress] = useState( window.headerVars.qualifiedAddress );
    const [shippingAddressUnit, setShippingAddressUnit] = useState( '' );
    const [billingAddress, setBillingAddress] = useState( window.headerVars.qualifiedAddress );
    const [billingAddressUnit, setBillingAddressUnit] = useState( '' );
    const [d2cOrderComplete, setD2cOrderComplete] = useState( false );
    const [internetServiceInCart, setInternetServiceInCart] = useState( false );
    const [serviceProvider, setServiceProvider] = useState( '' );
    const [doIncludeAmazonCard, setDoIncludeAmazonCard] = useState( false );
    const [canSelfInstall, setCanSelfInstall] = useState( '' );
    const [checkedForCoupon, setCheckedForCoupon] = useState( false );
    const [isNearNet, setIsNearNet] = useState(false);
    const [hasFibreUpgradeAgrement, setHasFibreUpgradeAgrement] = useState( window.headerVars.fibreUpgradeRequest );

    const [api, contextHolder] = notification.useNotification();

    //console.log('headerVars: ', window.headerVars); 

    useEffect(() => {
        let form_data = new FormData;
        form_data.append('action', 'startca_get_cart_contents');
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        const updateCartUpdateState = ({ detail }) => {
            setCartItemsMarkup( <Card loading={ true } title={ '' }></Card> );
            setCartTotalsMarkup( <></> );
            axios
            .post(requestUrl.ajax_url, form_data)
            .then(function(response){
                let cartData = response.data;
                //console.log("headerVars:::", headerVars);
                //console.log('cartData:: ', cartData);
                //console.log('checkedForCoupon:: ', checkedForCoupon);
                let isD2CSession = localStorage.getItem('is-d2c-session');
                let hasInternetServiceInCart = false;
                let hasTVServiceInCart = false;

                for( let i=0; i < cartData.length; i++ ) {
                    if( cartData[i]['qualification_obj'] ) {
                        setQualificationObject( cartData[i]['qualification_obj'] );
                        setQualifiedAddress( cartData[i]['qualification_obj'].address.address_string );
                        if( cartData[i]['qualification_obj']['services'].length ) {
                            setServiceProvider( cartData[i]['qualification_obj']['services'][0]['service']['provider'] );
                            setCanSelfInstall( cartData[i]['qualification_obj']['services'][0]['service']['self_install'] );
                        }
                    }

                    if( cartData[i].product_cat == 'internet-packages' ) {
                        hasInternetServiceInCart = true;
                    }
                    if( cartData[i].product_cat == 'tv-packages' ) {
                        hasTVServiceInCart = true;
                    }
                }

                if( hasInternetServiceInCart && 
                    hasTVServiceInCart && 
                    cartData[ cartData.length - 1 ].applied_coupon == '' &&
                    !checkedForCoupon ) {
                    applyBundledCoupon();
                }

                //console.log("cartData::: ", cartData[ cartData.length - 1 ]); 

                if( isD2CSession ) {
                    setIsD2C( true );
                }

                /*if( window.headerVars.installType == 'no-provider' &&
                    window.headerVars.installDate != ''
                 ) {
                    setActivationComponentCompleted( true );
                 }*/

                if( !hasInternetServiceInCart ) {
                    setActivationComponentCompleted( true );
                    setServiceAddressComponentCompleted( true );
                    setInternetServiceInCart( false );
                } else {
                    setInternetServiceInCart( true );
                    //setActivationComponentCompleted( false );
                    //setServiceAddressComponentCompleted( false );
                }

                if( cartData.length > 1 ) {
                    setCartHasItems( true );
                }

                setCartUpdateState( cartData );
                getCartItemsMarkup( cartData );
                getCartTotalsMarkup( cartData );

            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }

        document.addEventListener(`cartUpdateState`, updateCartUpdateState);
        

        if( firstName != '' && lastName != '' && email !== '' && phone != '' ) {
            setContactInfoComponentCompleted(true);
            setProgressCount(1);
        }

        if( paymentReceived ) { 
            console.log('payment recieved - scroll to top'); 
            document.getElementById('react-cart-container')?.scrollIntoView({behavior: 'smooth'});
            getCartItemsMarkup( cartUpdateState );
        }

        return () => document.removeEventListener(`cartUpdateState`, updateCartUpdateState);
    }, [
            setCartUpdateState, 
            paymentReceived,
            checkedForCoupon
    ]);

    const onIdle = () => {
        let form_data = new FormData;
        form_data.append('action', 'startca_handle_session_timeout');
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post( requestUrl.ajax_url, form_data )
        .then( function( response ){
            window.location.href = '/';
        })
        .catch(function ( error ) {
            console.log( error );
        })
        .finally( function () {
            // always executed 
        });
    }
    
    const idleTimer = useIdleTimer({ onIdle, timeout:10800_000 });
    //const idleTimer = useIdleTimer({ onIdle, timeout:10_000 });

    const handleCloseCart = () => { 
        jQuery("#cart-drawer").find('.off-canvas').removeClass('is-open');
        jQuery("#cart-drawer").find(".is-overlay-fixed").removeClass("is-visible");
        jQuery("#cart-drawer").find(".is-overlay-fixed").removeClass("is-closable");
    };

    const applyBundledCoupon = () => {
        let form_data = new FormData;
        form_data.append('action', 'startca_apply_coupon_for_bundled_internet_and_tv');
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        
        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function( response ){
            //console.log( "response: ", response.data );
            setCheckedForCoupon( true );
            document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed 
        });
    }

    const getProgressCount = () => {
        
        let count = 0;
        if( contactInfoComponentCompleted ) { 
            count++;
        }

        setProgressCount( count );
    }

    const getCartItemsMarkup = ( cartData ) => {
        let cartItems = [];
        if( cartData.length > 1 ) {
            setCartHasItems( true );
            cartItems = cartData.map( cartItem =>{
                if( cartItem.service_name) {
                    //console.log( 'paymentReceived:: ', paymentReceived );
                    return ( 
                        <div className="cart-item-row">
                            <span className="item-name">{ cartItem.service_name }</span>
                            <span className="item-price">
                                <span style={{ display: ( paymentReceived ) ? 'none' : 'inline-block' }}>
                                    <EditServiceButtons 
                                        productCategory={ cartItem.product_cat }
                                        productId={ cartItem.product_id }
                                        setInternetDrawerOpen={ setInternetDrawerOpen }
                                        setTvDrawerOpen={ setTvDrawerOpen }
                                        setPhoneDrawerOpen={ setPhoneDrawerOpen }
                                    />
                                </span>
                                { `$${cartItem.service_price}.00` }
                            </span>
                        </div>
                    )
                } 
            });
        } else {
            setCartHasItems( false );
            
            cartItems.push(<div className='empty-cart-message'>Your cart is empty. </div> );
        }

        setCartItemsMarkup( cartItems );
    }

    const getCartTotalsMarkup = ( cartData ) => {

        //console.log( "cartData:: ", cartData );

        if( cartData.length ) {
            let markup = [];
            for( let i=0; i < cartData.length; i++ ) {
                if( cartData[i].cart_subtotal ) {
                    markup.push( 
                        <div className="cart-item-row totals">
                            <span className="item-name">Subtotal</span>
                            <span className="item-price">{ `$${cartData[i].cart_subtotal}.00` }</span>
                        </div>
                    )
                }

                if( cartData[i].shipping ) {
                    markup.push( 
                        <div className="cart-item-row totals">
                            <span className="item-name">Shipping</span>
                            <span className="item-price">{ `$${cartData[i].shipping}.00` }</span>
                        </div>
                    )
                }

                if( cartData[i].activation ) {
                    markup.push( 
                        <div className="cart-item-row totals">
                            <span className="item-name">Activation</span>
                            <span className="item-price">{ `$${cartData[i].activation}.00` }</span>
                        </div>
                    )
                }

                if( cartData[i].discount ) {
                    if( cartData[i].discount > 0 ) {
                        markup.push( 
                            <div className="cart-item-row totals">
                                <span className="item-name">Discount</span>
                                <span className="item-price discount">{ `-$${cartData[i].discount}.00` }</span>
                            </div>
                        )
                    }
                }

                if( cartData[i].cart_taxes && cartData[i].cart_taxes > 0 ) {
                    markup.push( 
                        <div className="cart-item-row totals">
                            <span className="item-name">Taxes</span>
                            <span className="item-price">{ `$${cartData[i].cart_taxes}` }</span>
                        </div>
                    )
                }

                if( cartData[i].cart_total ) {
                    markup.push( 
                        <div className="cart-item-row total">
                            <div className='cart-item-total'>
                                <span className="item-name">Total</span>
                                <span className="item-price">{ `$${cartData[i].cart_total}` }</span>
                            </div>
                        </div>
                    )
                }
            }

            setCartTotalsMarkup( markup );
        }
    }

    const getUpsellsMarkup = () => {
        if( contactInfoComponentCompleted &&
            serviceAddressComponentCompleted &&
            !activationComponentCompleted  ) {
            return (
                <Upsells 
                    cartData={ cartUpdateState }
                    id='upsell-main'
                    title={ "Frequently purchased with" }
                    setTvDrawerOpen = { setTvDrawerOpen }
                />
            )
        } else {
            return ( <></> )
        }
    }

    const getResultsMarkup = () =>{
        if( paymentReceived ) {
            let fibreUpgradeListItem = ( hasFibreUpgradeAgrement == 'true' ) ? <li>Start.ca  will contact you to verify your Fibre upgrade, ( usually takes around 90 days ).</li> : <></>;
            return (
                <Result
                    status="success"
                    title="Your order has been received"
                    subTitle={ 
                        <div className="order-received-result-details">
                            <p><b>Thanks for choosing Start.ca!</b> Your order confirmation number is <b>{ orderConfirmationNumber }</b> and a confirmation email has been sent to <b>{ email }</b></p>
                            <p>Here’s what you can expect next:
                                <ol>
                                    <li>Once your request is confirmed you will receive an email with the details.</li>
                                    <li>Your equipment will be prepared for shipping.</li>
                                    <li>Please continue to check your phone/email for updates (incl. junk mail).</li>
                                    <li>Start.ca will also follow-up after activation to ensure smooth service.</li>
                                    { fibreUpgradeListItem }
                                </ol>
                            </p>
                        </div> }
                    extra={[
                        <>
                            <p><b>Questions?</b> Please contact us via phone or live chat.</p>
                            <Button
                                icon={ <PhoneOutlined /> }
                                type="primary"
                                href={ "tel:1-866-434-5888" }
                                style={ { 'marginRight' : '1rem' } }
                            > Call 1-866-434-5888</Button>
                            <Button 
                                className="live-chat-link"
                                icon={ <MessageOutlined /> }
                            >Start a Live Chat</Button>
                        </>
                    ]}
                />
            );
        }
    }

    const getCartTotal = () => {
        let cartTotal = '0.00';

        if( cartUpdateState.length ) {
            for( var i=0; i < cartUpdateState.length; i++ ) {
                if( cartUpdateState[i]['cart_total'] ) {
                    cartTotal = cartUpdateState[i]['cart_total'];
                }
            }
        }

        return cartTotal;
    }

    const handleTVDrawerClose = () =>{
        setTvDrawerOpen( false );
        document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
    }

    const handleInternetDrawerClose = () =>{
        setInternetDrawerOpen( false );
        document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
    }

    const handlePhoneDrawerClose = () =>{
        setPhoneDrawerOpen( false );
        document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
    }

    const handleEmailOrderToCustomer = () => {
        setPaymentIsProcessing( true );
        let cartItemIds = [];
        let availableServicesIds = [];
        let provider = '';
        let selfInstall = '';
        
        for( let i = 0; i < cartUpdateState.length; i++ ) {
            if( cartUpdateState[i]['product_id'] ) {
                cartItemIds.push( cartUpdateState[i]['product_id'] ); 
            }

            if( cartUpdateState[i]['qualification_obj'] ) {
                if( cartUpdateState[i]['qualification_obj'].services ) {
                    for( let j=0; j < cartUpdateState[i]['qualification_obj'].services.length; j++ ) {
                        availableServicesIds.push( cartUpdateState[i]['qualification_obj'].services[j].service.service_id ); 
                        provider = cartUpdateState[i]['qualification_obj'].services[j].service.provider;
                        selfInstall = cartUpdateState[i]['qualification_obj'].services[j].service.self_install;
                    }
                }
            }
        }

        let cartItems = cartItemIds.join( ',' );
        let availableServices = availableServicesIds.join( ',' );
        let customerFirstName = firstName;
        let customerLastName = lastName;
        let customerEmail = email;
        let customerPhone = phone;
        let shipToServiceAddress = '';
        let billToServiceAddress = '';
        let existingAccountNumber = '';
        let billingAddressInput = ( billingAddressUnit != '' ) ? billingAddress + ' Unit:' + billingAddressUnit : billingAddress ;
        let shippingAddressInput = ( shippingAddressUnit != '' ) ? shippingAddress + ' Unit:' + shippingAddressUnit : shippingAddress;
        
        console.log( 'cartItems: ', cartItems );
        console.log( 'availableServices: ', availableServices );
        console.log( 'provider: ', provider );
        console.log( 'selfInstall: ', selfInstall );
        console.log( 'customerFirstName: ', customerFirstName );
        console.log( 'customerLastName: ', customerLastName );
        console.log( 'customerEmail: ', customerEmail );
        console.log( 'customerPhone: ', customerPhone );
        console.log( 'billingAddressInput: ', billingAddressInput );
        console.log( 'shippingAddressInput: ', shippingAddressInput );
        console.log( 'lineType: ', lineType );
        
        let form_data = new FormData;
        form_data.append('action', 'setup_d2c_order');
        form_data.append('cart_items', cartItems);
        form_data.append('customer_first_name', customerFirstName);
        form_data.append('customer_last_name', customerLastName);
        form_data.append('customer_email', customerEmail);
        form_data.append('customer_phone', customerPhone); 
        form_data.append('existing_account_number', existingAccountNumber); 
        form_data.append('ship_to_service_address', shipToServiceAddress);
        form_data.append('bill_to_service_address', billToServiceAddress);
        form_data.append('billing_address', billingAddressInput);
        form_data.append('shipping_address', shippingAddressInput);
        form_data.append('available_services', availableServices);
        form_data.append('provider', provider);
        form_data.append('self_install', selfInstall);
        form_data.append('line_type', lineType);
        form_data.append('amazon_promo', doIncludeAmazonCard);
        form_data.append('includes_fibre_upgrade_agreement', hasFibreUpgradeAgrement);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        
        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function( response ){
            //let response = response.data;
            console.log( "response: ", response );
            setPaymentIsProcessing( false );
            setD2cOrderComplete( true );
            openNotification('bottom', 'd2c-order-complete');
            location.href = '/';
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed 
        });
    }

    const openNotification = ( placement, messageId='' ) => {
        switch( messageId ) {
            case 'd2c-order-complete': 
            api.info({
                message: "Order sent:",
                description: 'The order was processed successfully.',
                placement,
                icon: (
                    <SmileOutlined
                      style={{
                        color: '#d42d27',
                      }}
                    />
                ),
            });
        }
    }

    return (
        <div className="cart-container" id="react-cart-container">
            <div className='cart-container-content'>
                <div className="config-container">
                    <div className="off-canvas-title cart-header" >
                        <a href="/" rel="home">
                            <img className="logo-img normal" src={ logo } alt="Start.ca" />
                        </a>
                        <button 
                            className="cart-close-button cart-header-close-button" 
                            aria-label="" 
                            onClick={handleCloseCart}
                            id="tv-channel-drawer-closer"
                            tabindex="0"
                            type="button">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    { getResultsMarkup() }
                    <ContactInfo 
                        setFirstNameValid={ setFirstNameValid }
                        setLastNameValid={ setLastNameValid }
                        setPhoneNumberValid={ setPhoneNumberValid }
                        setEmailValid={ setEmailValid }
                        setFirstName={ setFirstName }
                        setLastName={ setLastName }
                        setEmail={ setEmail }
                        setPhone={ setPhone }
                        setCanContactCustomer={ setCanContactCustomer }
                        setContactInfoComponentCompleted={ setContactInfoComponentCompleted }
                        setProgressCount={ setProgressCount }
                        setLineType={ setLineType }
                        currentStep={ progressCount }
                        firstName={ firstName }
                        lastName={ lastName }
                        email={ email }
                        phone={ phone }
                        canContactCustomer={ canContactCustomer }
                        lineType={ lineType }
                        cartHasItems={ cartHasItems }
                        firstNameValid={ firstNameValid }
                        lastNameValid={ lastNameValid }
                        emailValid={ emailValid }
                        phoneNumberValid={ phoneNumberValid }
                        contactInfoComponentCompleted={ contactInfoComponentCompleted }
                        paymentReceived={ paymentReceived }
                        isD2C={ isD2C }
                    />
                    <ServiceAddress
                        setProgressCount={ setProgressCount }
                        setServiceAddressComponentCompleted={ setServiceAddressComponentCompleted }
                        qualifiedAddress={ qualifiedAddress }
                        cartHasItems={ cartHasItems }
                        currentStep={ progressCount }
                        contactInfoComponentCompleted={ contactInfoComponentCompleted }
                        paymentReceived={ paymentReceived }
                        shippingAddress={ shippingAddress }
                        setShippingAddress={ setShippingAddress }
                        shippingAddressUnit={ shippingAddressUnit }
                        setShippingAddressUnit={ setShippingAddressUnit }
                        billingAddress={ billingAddress }
                        setBillingAddress={ setBillingAddress }
                        billingAddressUnit={ billingAddressUnit }
                        setBillingAddressUnit={ setBillingAddressUnit }
                        internetServiceInCart={ internetServiceInCart }
                        
                    />
                    <ActivationDate
                        setActivationComponentCompleted={ setActivationComponentCompleted }
                        setProgressCount={ setProgressCount }
                        qualifiedAddress={ qualifiedAddress }
                        serviceProvider={ serviceProvider }
                        cartHasItems={ cartHasItems }
                        currentStep={ progressCount }
                        contactInfoComponentCompleted={ contactInfoComponentCompleted }
                        serviceAddressComponentCompleted={ serviceAddressComponentCompleted }
                        activationComponentCompleted={ activationComponentCompleted }
                        paymentReceived={ paymentReceived }
                        internetServiceInCart={ internetServiceInCart }
                        isD2C={ isD2C }
                        canSelfInstall={ canSelfInstall }
                    />

                    { /*getUpsellsMarkup()*/ }

                    <GoogleReCaptchaProvider reCaptchaKey="6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ">
                        <PaymentDetails
                            cartTotal={ getCartTotal() }
                            cartHasItems={ cartHasItems }
                            setCartHasItems={ setCartHasItems }
                            contactInfoComponentCompleted={ contactInfoComponentCompleted }
                            serviceAddressComponentCompleted={ serviceAddressComponentCompleted }
                            activationComponentCompleted={ activationComponentCompleted }
                            setPaymentComponentCompleted={ setPaymentComponentCompleted }
                            paymentComponentCompleted={ paymentComponentCompleted }
                            setPaymentReceived={ setPaymentReceived }
                            paymentReceived={ paymentReceived }
                            setOrderConfirmationNumber={ setOrderConfirmationNumber }
                            isD2C={ isD2C }
                            handleEmailOrderToCustomer={ handleEmailOrderToCustomer }
                            paymentIsProcessing={ paymentIsProcessing }
                            d2cOrderComplete={ d2cOrderComplete }
                            setPaymentIsProcessing={ setPaymentIsProcessing }
                            qualificationObject={ qualificationObject }
                            setDoIncludeAmazonCard={ setDoIncludeAmazonCard }
                            doIncludeAmazonCard={ doIncludeAmazonCard }
                            setIsNearNet={ setIsNearNet }
                            isNearNet={ isNearNet }
                            setHasFibreUpgradeAgrement={ setHasFibreUpgradeAgrement }
                            hasFibreUpgradeAgrement={ hasFibreUpgradeAgrement }
                        />
                    </GoogleReCaptchaProvider>
                    
                </div>

                <div id="order-summary" className="order-summary">
                    <div className='order-summary-header'>
                        <button 
                            className="cart-close-button" 
                            aria-label="" 
                            onClick={handleCloseCart}
                            id="tv-channel-drawer-closer"
                            tabindex="0"
                            type="button">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className='order-summary-content-container'>
                        <OrderCompletionSteps 
                            currentStep={ progressCount }
                            cartHasItems={ cartHasItems }
                            paymentReceived={ paymentReceived }
                        />
                        <CartTotals 
                            cartItems={ cartItemsMarkup } 
                            cartTotals={ cartTotalsMarkup }
                            cartData={ cartUpdateState }
                            paymentReceived={ paymentReceived }
                        />
                        <Referrals 
                            paymentReceived={ paymentReceived }
                        />
                        {/* <Upsells 
                            cartData={ cartUpdateState }
                            id="upsell-order-summary"
                            //title={ "Complete your package" }
                            paymentReceived={ paymentReceived }
                            setTvDrawerOpen={ setTvDrawerOpen }
                            setInternetDrawerOpen={ setInternetDrawerOpen }
                            setPhoneDrawerOpen={ setPhoneDrawerOpen }
                        /> */}
                    </div>
                </div>
            </div>
            <Drawer
                title={ "Add tv" }
                placement="bottom"
                className='upsell-drawers'
                size="large"
                onClose={ handleTVDrawerClose }
                open={ tvDrawerOpen }
                extra={ [] }
            >
                <div className='tv-drawer-container'>
                    <div className='grid-container'>
                        <TVServices />
                    </div>
                </div>
            </Drawer>
            <Drawer
                className='upsell-drawers'
                title={ "Add internet" }
                placement="bottom"
                size="large"
                onClose={ handleInternetDrawerClose }
                open={ internetDrawerOpen }
                extra={ [] }
            >
                <div className='tv-drawer-container'>
                    <div className='grid-container'>
                        <InternetServices isCartComponent={ true }/>
                    </div>
                </div>
            </Drawer>
            <Drawer
                title={ "Add home phone" }
                placement="bottom"
                className='upsell-drawers'
                size="large"
                onClose={ handlePhoneDrawerClose }
                open={ phoneDrawerOpen }
                extra={ [] }
            >
                <div className='tv-drawer-container'>
                    <div className='grid-container'>
                        <PhoneServices isCartComponent={ true }/>
                    </div>
                </div>
            </Drawer>
            { contextHolder } 
        </div>
    )
}

export default Cart